"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePackageFile = exports.getSchemaVersionFromPackageFile = exports.validatePackageFileInBrowser = exports.upgradePackageFile = exports.parsePackageFileJSON = exports.parsePackageFileJSONInBrowser = exports.loadPackageFileFromDisk = exports.compatibilityToString = exports.nextVersion = exports.diffCompatibility = exports.compareConfigObjects = exports.compareArrays = exports.sourceURIsEquivalent = exports.compareProperties = exports.compareSchema = exports.compareSource = exports.compareStream = exports.compareSources = exports.compareSchemas = exports.comparePackages = exports.leastCompatible = exports.DifferenceType = exports.Compability = void 0;
const semver_1 = require("semver");
const fs_1 = __importDefault(require("fs"));
const path_1 = __importDefault(require("path"));
const ajv_1 = __importDefault(require("ajv"));
const cross_fetch_1 = __importDefault(require("cross-fetch"));
const PackageFile_v0_2_0_1 = require("./PackageFile-v0.2.0");
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
const PackageFile_v0_32_1_1 = require("./PackageFile-v0.32.1");
const DataPMVersion_1 = require("./DataPMVersion");
var Compability;
(function (Compability) {
    Compability[Compability["Identical"] = 0] = "Identical";
    Compability[Compability["MinorChange"] = 1] = "MinorChange";
    Compability[Compability["CompatibleChange"] = 2] = "CompatibleChange";
    Compability[Compability["BreakingChange"] = 3] = "BreakingChange";
})(Compability = exports.Compability || (exports.Compability = {}));
var DifferenceType;
(function (DifferenceType) {
    DifferenceType["REMOVE_SCHEMA"] = "REMOVE_SCHEMA";
    DifferenceType["REMOVE_HIDDEN_SCHEMA"] = "REMOVE_HIDDEN_SCHEMA";
    DifferenceType["ADD_SCHEMA"] = "ADD_SCHEMA";
    DifferenceType["REMOVE_SOURCE"] = "REMOVE_SOURCE";
    DifferenceType["CHANGE_PACKAGE_DISPLAY_NAME"] = "CHANGE_PACKAGE_DISPLAY_NAME";
    DifferenceType["CHANGE_PACKAGE_DESCRIPTION"] = "CHANGE_PACKAGE_DESCRIPTION";
    DifferenceType["CHANGE_SOURCE"] = "CHANGE_SOURCE";
    DifferenceType["CHANGE_SOURCE_CONNECTION"] = "CHANGE_SOURCE_CONNECTION";
    DifferenceType["CHANGE_SOURCE_CREDENTIALS"] = "CHANGE_SOURCE_CREDENTIALS";
    DifferenceType["CHANGE_SOURCE_CONFIGURATION"] = "CHANGE_SOURCE_CONFIGURATION";
    DifferenceType["CHANGE_STREAM_UPDATE_METHOD"] = "CHANGE_STREAM_UPDATE_METHOD";
    DifferenceType["CHANGE_SOURCE_URIS"] = "CHANGE_SOURCE_URIS";
    DifferenceType["CHANGE_STREAM_STATS"] = "CHANGE_STREAM_STATS";
    DifferenceType["CHANGE_STREAM_UPDATE_HASH"] = "CHANGE_STREAM_UPDATE_HASH";
    DifferenceType["ADD_PROPERTY"] = "ADD_PROPERTY";
    DifferenceType["HIDE_PROPERTY"] = "HIDE_PROPERTY";
    DifferenceType["UNHIDE_PROPERTY"] = "UNHIDE_PROPERTY";
    DifferenceType["REMOVE_PROPERTY"] = "REMOVE_PROPERTY";
    DifferenceType["REMOVE_HIDDEN_PROPERTY"] = "REMOVE_HIDDEN_PROPERTY";
    DifferenceType["CHANGE_PROPERTY_TYPE"] = "CHANGE_PROPERTY_TYPE";
    DifferenceType["CHANGE_PROPERTY_FORMAT"] = "CHANGE_PROPERTY_FORMAT";
    DifferenceType["CHANGE_PROPERTY_UNIT"] = "CHANGE_PROPERTY_UNIT";
    DifferenceType["CHANGE_PROPERTY_DESCRIPTION"] = "CHANGE_PROPERTY_DESCRIPTION";
    DifferenceType["CHANGE_GENERATED_BY"] = "CHANGE_GENERATED_BY";
    DifferenceType["CHANGE_UPDATED_DATE"] = "CHANGE_UPDATED_DATE";
    DifferenceType["CHANGE_VERSION"] = "CHANGE_VERSION";
    DifferenceType["CHANGE_README_MARKDOWN"] = "CHANGE_README_MARKDOWN";
    DifferenceType["CHANGE_LICENSE_MARKDOWN"] = "CHANGE_LICENSE_MARKDOWN";
    DifferenceType["CHANGE_README_FILE"] = "CHANGE_README_FILE";
    DifferenceType["CHANGE_LICENSE_FILE"] = "CHANGE_LICENSE_FILE";
    DifferenceType["CHANGE_WEBSITE"] = "CHANGE_WEBSITE";
    DifferenceType["CHANGE_CONTACT_EMAIL"] = "CHANGE_CONTACT_EMAIL";
    DifferenceType["REMOVE_STREAM_SET"] = "REMOVE_STREAM_SET";
})(DifferenceType = exports.DifferenceType || (exports.DifferenceType = {}));
function leastCompatible(a, b) {
    if (a === b)
        return a;
    if (a < b)
        return b;
    return a;
}
exports.leastCompatible = leastCompatible;
function comparePackages(packageA, packageB) {
    let response = [];
    if (packageA.description !== packageB.description)
        response.push({
            type: DifferenceType.CHANGE_PACKAGE_DESCRIPTION,
            pointer: "#"
        });
    if (packageA.displayName !== packageB.displayName)
        response.push({
            type: DifferenceType.CHANGE_PACKAGE_DISPLAY_NAME,
            pointer: "#"
        });
    if (packageA.version !== packageB.version) {
        response.push({
            type: DifferenceType.CHANGE_VERSION,
            pointer: "#"
        });
    }
    if (packageA.readmeFile !== packageB.readmeFile) {
        response.push({
            type: DifferenceType.CHANGE_README_FILE,
            pointer: "#"
        });
    }
    if (packageA.website !== packageB.website) {
        response.push({
            type: DifferenceType.CHANGE_WEBSITE,
            pointer: "#"
        });
    }
    if (packageA.contactEmail !== packageB.contactEmail) {
        response.push({
            type: DifferenceType.CHANGE_CONTACT_EMAIL,
            pointer: "#"
        });
    }
    if (packageA.readmeMarkdown !== packageB.readmeMarkdown) {
        response.push({
            type: DifferenceType.CHANGE_README_MARKDOWN,
            pointer: "#"
        });
    }
    if (packageA.licenseFile !== packageB.licenseFile) {
        response.push({
            type: DifferenceType.CHANGE_LICENSE_FILE,
            pointer: "#"
        });
    }
    if (packageA.licenseMarkdown !== packageB.licenseMarkdown) {
        response.push({
            type: DifferenceType.CHANGE_LICENSE_MARKDOWN,
            pointer: "#"
        });
    }
    if (packageA.generatedBy !== packageB.generatedBy)
        response.push({ type: DifferenceType.CHANGE_GENERATED_BY, pointer: "#" });
    if (packageA.updatedDate.getTime() !== packageB.updatedDate.getTime())
        response.push({ type: DifferenceType.CHANGE_UPDATED_DATE, pointer: "#" });
    response = response.concat(compareSchemas(packageA.schemas, packageB.schemas));
    response = response.concat(compareSources(packageA.sources, packageB.sources));
    return response;
}
exports.comparePackages = comparePackages;
function compareSchemas(priorSchemas, newSchemas) {
    let response = [];
    for (const schemaA of priorSchemas) {
        let found = false;
        for (const schemaB of newSchemas) {
            if (schemaA.title !== schemaB.title)
                continue;
            found = true;
            response = response.concat(compareSchema(schemaA, schemaB, "#"));
        }
        if (!found) {
            if (schemaA.hidden === true) {
                response.push({
                    type: DifferenceType.REMOVE_HIDDEN_SCHEMA,
                    pointer: ""
                });
            }
            else {
                response.push({
                    type: DifferenceType.REMOVE_SCHEMA,
                    pointer: ""
                });
            }
        }
    }
    return response;
}
exports.compareSchemas = compareSchemas;
function compareSources(priorSources, newSources) {
    let response = [];
    for (const sourceA of priorSources) {
        let found = false;
        for (const sourceB of newSources) {
            if (sourceA.slug !== sourceB.slug)
                continue;
            found = true;
            response = response.concat(compareSource(sourceA, sourceB, "#"));
        }
        if (!found)
            response.push({
                type: DifferenceType.REMOVE_SOURCE,
                pointer: ""
            });
    }
    return response;
}
exports.compareSources = compareSources;
function compareStream(priorStreamSet, newStreamSet, pointer = "#") {
    const response = [];
    if (priorStreamSet.streamStats.inspectedCount !== newStreamSet.streamStats.inspectedCount) {
        response.push({ type: DifferenceType.CHANGE_STREAM_STATS, pointer });
    }
    else if (priorStreamSet.streamStats.inspectedCount !== newStreamSet.streamStats.inspectedCount) {
        response.push({ type: DifferenceType.CHANGE_STREAM_STATS, pointer });
    }
    else if (priorStreamSet.streamStats.inspectedCount !== newStreamSet.streamStats.inspectedCount) {
        response.push({ type: DifferenceType.CHANGE_STREAM_STATS, pointer });
    }
    else if (priorStreamSet.streamStats.inspectedCount !== newStreamSet.streamStats.inspectedCount) {
        response.push({ type: DifferenceType.CHANGE_STREAM_STATS, pointer });
    }
    if (priorStreamSet.lastUpdateHash !== newStreamSet.lastUpdateHash && priorStreamSet.lastUpdateHash != null) {
        response.push({ type: DifferenceType.CHANGE_STREAM_UPDATE_HASH, pointer: pointer });
    }
    return response;
}
exports.compareStream = compareStream;
function compareSource(priorSource, newSource, pointer = "#") {
    let response = [];
    if (priorSource == null && newSource != null) {
        response.push({ type: DifferenceType.CHANGE_SOURCE, pointer: pointer });
    }
    else if (newSource == null && priorSource != null) {
        response.push({ type: DifferenceType.CHANGE_SOURCE, pointer: pointer });
    }
    else if (priorSource != null && newSource != null) {
        if (priorSource.type !== newSource.type) {
            response.push({ type: DifferenceType.CHANGE_SOURCE, pointer: pointer });
        }
        else {
            const configComparison = compareConfigObjects(priorSource.configuration, newSource.configuration);
            if (!configComparison)
                response.push({ type: DifferenceType.CHANGE_SOURCE_CONFIGURATION, pointer: pointer });
            const connectionComparison = compareConfigObjects(priorSource.connectionConfiguration, newSource.connectionConfiguration);
            if (!connectionComparison)
                response.push({ type: DifferenceType.CHANGE_SOURCE_CONNECTION, pointer: pointer });
            if (priorSource.credentialsIdentifier !== newSource.credentialsIdentifier)
                response.push({ type: DifferenceType.CHANGE_SOURCE_CREDENTIALS, pointer: pointer });
        }
    }
    for (const priorStreamSet of priorSource.streamSets) {
        const newStreamSet = newSource.streamSets.find((ssB) => ssB.slug === priorStreamSet.slug);
        if (!newStreamSet) {
            response.push({ type: DifferenceType.REMOVE_STREAM_SET, pointer });
            continue;
        }
        const updateMethodComparison = compareArrays(newStreamSet.updateMethods, priorStreamSet.updateMethods);
        if (!updateMethodComparison) {
            response.push({ type: DifferenceType.CHANGE_STREAM_UPDATE_METHOD, pointer });
        }
        response = response.concat(compareStream(priorStreamSet, newStreamSet, pointer));
    }
    return response;
}
exports.compareSource = compareSource;
function compareSchema(priorSchema, newSchema, pointer = "#") {
    pointer += "/" + newSchema.title;
    const response = compareProperties(priorSchema.properties, newSchema.properties, pointer);
    return response;
}
exports.compareSchema = compareSchema;
function compareProperties(priorProperties, newProperties, pointer = "#") {
    var _a, _b;
    const response = [];
    for (const priorKey of Object.keys(priorProperties)) {
        const propertyPointer = pointer + "/properties/" + priorKey;
        const newKeys = Object.keys(newProperties);
        if (newKeys.indexOf(priorKey) === -1) {
            if (priorProperties[priorKey].hidden) {
                response.push({
                    type: DifferenceType.REMOVE_HIDDEN_PROPERTY,
                    pointer: propertyPointer
                });
            }
            else {
                response.push({
                    type: DifferenceType.REMOVE_PROPERTY,
                    pointer: propertyPointer
                });
            }
            continue;
        }
        const priorProperty = priorProperties[priorKey];
        const newProperty = newProperties[priorKey];
        if (priorProperty.description !== newProperty.description)
            response.push({
                type: DifferenceType.CHANGE_PROPERTY_DESCRIPTION,
                pointer: propertyPointer
            });
        const priorSchemaValueTypes = Object.keys(priorProperty.types);
        const newSchemaValueTypes = Object.keys((_a = newProperty.types) !== null && _a !== void 0 ? _a : []);
        if (!priorSchemaValueTypes.every((v) => newSchemaValueTypes.indexOf(v) !== -1) ||
            !newSchemaValueTypes.every((v) => priorSchemaValueTypes.indexOf(v) !== -1))
            response.push({ type: DifferenceType.CHANGE_PROPERTY_TYPE, pointer: propertyPointer });
        if (priorProperty.hidden !== true && newProperty.hidden === true) {
            response.push({ type: DifferenceType.HIDE_PROPERTY, pointer: propertyPointer });
        }
        else if (priorProperty.hidden === true && newProperty.hidden !== true) {
            response.push({ type: DifferenceType.UNHIDE_PROPERTY, pointer: propertyPointer });
        }
        if (priorProperty.unit !== newProperty.unit)
            response.push({ type: DifferenceType.CHANGE_PROPERTY_UNIT, pointer: propertyPointer });
    }
    for (const newKey of Object.keys(newProperties)) {
        const propertyPointer = pointer + "/properties/" + newKey;
        const priorProperty = priorProperties[newKey];
        if (priorProperty == null) {
            response.push({
                type: DifferenceType.ADD_PROPERTY,
                pointer: propertyPointer
            });
        }
        else if (((_b = priorProperty.types.object) === null || _b === void 0 ? void 0 : _b.objectProperties) != null && newProperties[newKey].types.object != null) {
            const changes = compareProperties(priorProperty.types.object.objectProperties, newProperties[newKey].types.object.objectProperties, propertyPointer);
            response.push(...changes);
        }
    }
    return response;
}
exports.compareProperties = compareProperties;
function sourceURIsEquivalent(urisA, urisB) {
    for (const a of urisA) {
        if (!urisB.includes(a))
            return false;
    }
    for (const b of urisB) {
        if (!urisA.includes(b))
            return false;
    }
    return true;
}
exports.sourceURIsEquivalent = sourceURIsEquivalent;
function compareArrays(priorArray, newArray) {
    if (priorArray == null && newArray == null)
        return true;
    if ((priorArray == null && newArray != null) || (priorArray != null && newArray == null))
        return false;
    return (0, fast_deep_equal_1.default)(priorArray, newArray);
}
exports.compareArrays = compareArrays;
function compareConfigObjects(priorObject, newObject) {
    if (priorObject == null && newObject == null)
        return true;
    if ((priorObject == null && newObject != null) || (priorObject != null && newObject == null))
        return false;
    return (0, fast_deep_equal_1.default)(priorObject, newObject);
}
exports.compareConfigObjects = compareConfigObjects;
function diffCompatibility(diffs) {
    let returnValue = Compability.Identical;
    diffs.forEach((d) => {
        switch (d.type) {
            case DifferenceType.REMOVE_PROPERTY:
            case DifferenceType.REMOVE_SCHEMA:
            case DifferenceType.CHANGE_PROPERTY_FORMAT:
            case DifferenceType.CHANGE_PROPERTY_TYPE:
            case DifferenceType.HIDE_PROPERTY:
                returnValue = Compability.BreakingChange;
                break;
            case DifferenceType.ADD_PROPERTY:
            case DifferenceType.ADD_SCHEMA:
            case DifferenceType.UNHIDE_PROPERTY:
                returnValue = Math.max(returnValue, Compability.CompatibleChange);
                break;
            case DifferenceType.CHANGE_SOURCE:
            case DifferenceType.CHANGE_SOURCE_CONFIGURATION:
            case DifferenceType.CHANGE_SOURCE_CONNECTION:
            case DifferenceType.CHANGE_SOURCE_CREDENTIALS:
            case DifferenceType.REMOVE_HIDDEN_PROPERTY:
            case DifferenceType.REMOVE_HIDDEN_SCHEMA:
            case DifferenceType.CHANGE_VERSION:
            case DifferenceType.REMOVE_SOURCE:
            case DifferenceType.REMOVE_STREAM_SET:
            case DifferenceType.CHANGE_PROPERTY_UNIT:
            case DifferenceType.CHANGE_PACKAGE_DESCRIPTION:
            case DifferenceType.CHANGE_PACKAGE_DISPLAY_NAME:
            case DifferenceType.CHANGE_PROPERTY_DESCRIPTION:
            case DifferenceType.CHANGE_README_MARKDOWN:
            case DifferenceType.CHANGE_LICENSE_MARKDOWN:
            case DifferenceType.CHANGE_WEBSITE:
            case DifferenceType.CHANGE_CONTACT_EMAIL:
                returnValue = Math.max(returnValue, Compability.MinorChange);
                break;
            case DifferenceType.CHANGE_STREAM_UPDATE_HASH:
            case DifferenceType.CHANGE_STREAM_STATS:
            case DifferenceType.CHANGE_GENERATED_BY:
            case DifferenceType.CHANGE_UPDATED_DATE:
            case DifferenceType.CHANGE_README_FILE:
            case DifferenceType.CHANGE_LICENSE_FILE:
            case DifferenceType.CHANGE_STREAM_UPDATE_METHOD:
                break;
            default:
                throw new Error("Diff type " + d.type + " not mapped");
        }
    });
    return returnValue;
}
exports.diffCompatibility = diffCompatibility;
function nextVersion(currentVersion, diffCompatibility) {
    const copy = new semver_1.SemVer(currentVersion.version);
    switch (diffCompatibility) {
        case Compability.BreakingChange:
            return copy.inc("major");
        case Compability.CompatibleChange:
            return copy.inc("minor");
        case Compability.MinorChange:
            return copy.inc("patch");
        case Compability.Identical:
            return copy;
        default:
            throw new Error("Unrecognized compability " + diffCompatibility);
    }
}
exports.nextVersion = nextVersion;
function compatibilityToString(compatibility) {
    switch (compatibility) {
        case Compability.BreakingChange:
            return "breaking";
        case Compability.CompatibleChange:
            return "compatibile";
        case Compability.MinorChange:
            return "minor";
        case Compability.Identical:
            return "no";
        default:
            throw new Error("Compatibility " + compatibility + " not recognized");
    }
}
exports.compatibilityToString = compatibilityToString;
function loadPackageFileFromDisk(packageFilePath) {
    if (!fs_1.default.existsSync(packageFilePath))
        throw new Error("FILE_NOT_FOUND - " + packageFilePath);
    let packageFileAbsolutePath;
    if (path_1.default.isAbsolute(packageFilePath)) {
        packageFileAbsolutePath = path_1.default.dirname(packageFilePath);
    }
    else {
        packageFileAbsolutePath = process.cwd() + path_1.default.sep + path_1.default.dirname(packageFilePath);
    }
    let packageFile;
    const packageFileContents = fs_1.default.readFileSync(packageFilePath).toString();
    try {
        packageFile = parsePackageFileJSON(packageFileContents);
    }
    catch (error) {
        throw new Error("PACKAGE_PARSE_ERROR: " + error.message);
    }
    if (packageFile.readmeFile != null) {
        const readmeFileAbsolutePath = packageFileAbsolutePath + path_1.default.sep + packageFile.readmeFile;
        if (!fs_1.default.existsSync(readmeFileAbsolutePath)) {
            throw new Error("README_FILE_NOT_FOUND: " + readmeFileAbsolutePath);
        }
        packageFile.readmeMarkdown = fs_1.default.readFileSync(readmeFileAbsolutePath).toString();
        delete packageFile.readmeFile;
    }
    if (packageFile.licenseFile != null) {
        const licenseFileAbsolutePath = packageFileAbsolutePath + path_1.default.sep + packageFile.licenseFile;
        if (!fs_1.default.existsSync(licenseFileAbsolutePath)) {
            throw new Error("LICENSE_FILE_NOT_FOUND: " + licenseFileAbsolutePath);
        }
        packageFile.licenseMarkdown = fs_1.default.readFileSync(licenseFileAbsolutePath).toString();
        delete packageFile.licenseFile;
    }
    return packageFile;
}
exports.loadPackageFileFromDisk = loadPackageFileFromDisk;
function massagePackageFile(packageFile) {
    if (typeof packageFile.updatedDate === "string") {
        packageFile.updatedDate = new Date(packageFile.updatedDate);
    }
    for (const schema of packageFile.schemas) {
        for (const propertyKey of Object.keys(schema.properties)) {
            const property = schema.properties[propertyKey];
            massageProperty(property);
        }
    }
}
function massageProperty(property) {
    if (typeof property.firstSeen === "string") {
        property.firstSeen = new Date(property.firstSeen);
    }
    if (typeof property.lastSeen === "string") {
        property.lastSeen = new Date(property.lastSeen);
    }
    massageValueTypeStats(property.types);
}
function massageValueTypeStats(valueTypes) {
    var _a, _b, _c, _d;
    if (valueTypes == null)
        return;
    if (typeof ((_a = valueTypes.date) === null || _a === void 0 ? void 0 : _a.dateMaxValue) === "string") {
        valueTypes.date.dateMaxValue = new Date(valueTypes.date.dateMaxValue);
    }
    if (typeof ((_b = valueTypes.date) === null || _b === void 0 ? void 0 : _b.dateMinValue) === "string") {
        valueTypes.date.dateMinValue = new Date(valueTypes.date.dateMinValue);
    }
    if (((_c = valueTypes.array) === null || _c === void 0 ? void 0 : _c.arrayTypes) != null) {
        massageValueTypeStats(valueTypes.array.arrayTypes);
    }
    if (((_d = valueTypes.object) === null || _d === void 0 ? void 0 : _d.objectProperties) != null) {
        for (const property of Object.values(valueTypes.object.objectProperties)) {
            massageProperty(property);
        }
    }
}
async function parsePackageFileJSONInBrowser(packageFileString) {
    try {
        let packageFile = JSON.parse(packageFileString);
        await validatePackageFileInBrowser(packageFile);
        massagePackageFile(packageFile);
        packageFile = upgradePackageFile(packageFile);
        return packageFile;
    }
    catch (error) {
        throw new Error("ERROR_PARSING_PACKAGE_FILE - " + error.message);
    }
}
exports.parsePackageFileJSONInBrowser = parsePackageFileJSONInBrowser;
function parsePackageFileJSON(packageFileString) {
    try {
        let packageFile = JSON.parse(packageFileString);
        const isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined";
        validatePackageFile(packageFile);
        massagePackageFile(packageFile);
        packageFile = upgradePackageFile(packageFile);
        return packageFile;
    }
    catch (error) {
        throw new Error("ERROR_PARSING_PACKAGE_FILE - " + error.message);
    }
}
exports.parsePackageFileJSON = parsePackageFileJSON;
function upgradePackageFile(packageFileObject) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    if (packageFileObject.$schema == null) {
        packageFileObject.$schema = "https://datapm.io/docs/package-file-schema-v0.2.0.json";
        const oldPackageFile = packageFileObject;
        for (const schema of oldPackageFile.schemas) {
            schema.recordsInspectedCount = schema.recordCount;
            schema.recordCountPrecision =
                schema.recordCountApproximate === true ? PackageFile_v0_2_0_1.CountPrecisionV020.APPROXIMATE : PackageFile_v0_2_0_1.CountPrecisionV020.EXACT;
            delete schema.recordCountApproximate;
        }
    }
    if (packageFileObject.$schema === "https://datapm.io/docs/package-file-schema-v0.2.0.json") {
        packageFileObject.$schema = "https://datapm.io/docs/package-file-schema-v0.3.0.json";
        const oldPackageFile = packageFileObject;
        const newPackagefile = packageFileObject;
        for (const schema of oldPackageFile.schemas) {
            if (schema && schema.source) {
                newPackagefile.sources = [
                    {
                        slug: (_a = schema.source) === null || _a === void 0 ? void 0 : _a.uri,
                        type: (_b = schema.source) === null || _b === void 0 ? void 0 : _b.type,
                        uris: [(_c = schema.source) === null || _c === void 0 ? void 0 : _c.uri],
                        configuration: (_d = schema.source) === null || _d === void 0 ? void 0 : _d.configuration,
                        streamSets: [
                            {
                                slug: (_e = schema.source) === null || _e === void 0 ? void 0 : _e.uri,
                                configuration: {},
                                schemaTitles: [schema.title],
                                lastUpdateHash: (_f = schema.source) === null || _f === void 0 ? void 0 : _f.lastUpdateHash,
                                streamStats: {
                                    inspectedCount: schema.recordsInspectedCount || 0,
                                    byteCount: schema.byteCount,
                                    byteCountPrecision: schema.byteCountPrecision,
                                    recordCount: schema.recordCount,
                                    recordCountPrecision: schema.recordCountPrecision
                                }
                            }
                        ]
                    }
                ];
                delete schema.source;
            }
        }
    }
    if (packageFileObject.$schema === "https://datapm.io/docs/package-file-schema-v0.3.0.json") {
        packageFileObject.$schema = "https://datapm.io/docs/package-file-schema-v0.4.0.json";
        const oldPackageFile = packageFileObject;
        for (const oldSchema of oldPackageFile.schemas) {
            for (const propertyName in oldSchema.properties) {
                const property = oldSchema.properties[propertyName];
                for (const oldValueTypeName in property.valueTypes) {
                    const oldValueType = property.valueTypes[oldValueTypeName];
                    if (oldValueType.dateMaxValue === null) {
                        delete oldValueType.dateMaxValue;
                    }
                    if (oldValueType.dateMinValue === null) {
                        delete oldValueType.dateMinValue;
                    }
                    if (typeof oldValueType.numberMaxValue === "string") {
                        const oldValueTypeString = oldValueType.numberMaxValue;
                        const newValueTypeStatistic = property.valueTypes[oldValueTypeName];
                        try {
                            if (oldValueTypeString.indexOf(".") !== -1) {
                                newValueTypeStatistic.numberMaxValue = Number.parseFloat(oldValueTypeString);
                            }
                            else {
                                newValueTypeStatistic.numberMaxValue = Number.parseInt(oldValueTypeString);
                            }
                        }
                        catch (error) {
                            delete newValueTypeStatistic.numberMaxValue;
                        }
                    }
                    if (typeof oldValueType.numberMinValue === "string") {
                        const oldValueTypeString = oldValueType.numberMinValue;
                        const newValueTypeStatistic = property.valueTypes[oldValueTypeName];
                        try {
                            if (oldValueTypeString.indexOf(".") !== -1) {
                                newValueTypeStatistic.numberMinValue = Number.parseFloat(oldValueTypeString);
                            }
                            else {
                                newValueTypeStatistic.numberMinValue = Number.parseInt(oldValueTypeString);
                            }
                        }
                        catch (error) {
                            delete newValueTypeStatistic.numberMinValue;
                        }
                    }
                }
            }
        }
    }
    if (packageFileObject.$schema === "https://datapm.io/docs/package-file-schema-v0.4.0.json") {
        packageFileObject.$schema = "https://datapm.io/docs/package-file-schema-v0.5.0.json";
        const oldPackageFile = packageFileObject;
        for (const oldSchema of oldPackageFile.sources) {
            oldSchema.configuration.uris = oldSchema.uris;
        }
    }
    if (packageFileObject.$schema === "https://datapm.io/docs/package-file-schema-v0.5.0.json") {
        packageFileObject.$schema = "https://datapm.io/docs/package-file-schema-v0.6.0.json";
        const oldPackageFile = packageFileObject;
        for (const oldSource of oldPackageFile.sources) {
            const newSource = oldSource;
            newSource.connectionConfiguration = oldSource.configuration || {};
        }
    }
    if (packageFileObject.$schema === "https://datapm.io/docs/package-file-schema-v0.6.0.json") {
        packageFileObject.$schema = "https://datapm.io/docs/package-file-schema-v0.7.0.json";
        const oldPackageFile = packageFileObject;
        for (const oldRegistry of oldPackageFile.registries || []) {
            const newRegistry = oldRegistry;
            newRegistry.publishMethod = PackageFile_v0_32_1_1.PublishMethod.SCHEMA_ONLY;
        }
    }
    if (packageFileObject.$schema === "https://datapm.io/docs/package-file-schema-v0.7.0.json") {
        packageFileObject.$schema = "https://datapm.io/docs/package-file-schema-v0.8.0.json";
        const oldPackageFile = packageFileObject;
        const newPackageFile = oldPackageFile;
        if (newPackageFile.canonical == null) {
            newPackageFile.canonical = true;
        }
    }
    if (packageFileObject.$schema === "https://datapm.io/docs/package-file-schema-v0.8.0.json") {
        packageFileObject.$schema = "https://datapm.io/docs/package-file-schema-v0.8.1.json";
        const oldPackageFile = packageFileObject;
        const newPackageFile = oldPackageFile;
        for (const source of newPackageFile.sources) {
            for (const streamSet of source.streamSets) {
                if (streamSet.updateMethods == null) {
                    streamSet.updateMethods = [];
                }
            }
        }
    }
    if (packageFileObject.$schema === "https://datapm.io/docs/package-file-schema-v0.8.1.json") {
        const packageFile = packageFileObject;
        for (const source of packageFile.sources) {
            if (((_g = source.configuration) === null || _g === void 0 ? void 0 : _g.filePattern) != null) {
                source.configuration.fileRegex = source.configuration.filePattern;
                delete source.configuration.filePattern;
            }
        }
    }
    if (packageFileObject.$schema === "https://datapm.io/docs/package-file-schema-v0.8.1.json") {
        packageFileObject.$schema = "https://datapm.io/docs/package-file-schema-v0.9.0.json";
        const oldPackageFile = packageFileObject;
        const newPackageFile = oldPackageFile;
        for (const schema of oldPackageFile.schemas) {
            const oldSchemaProperties = (_h = schema.properties) !== null && _h !== void 0 ? _h : {};
            for (const propertyKey of Object.keys(oldSchemaProperties)) {
                const oldProperty = oldSchemaProperties[propertyKey];
                const newProperty = newPackageFile.schemas.find((s) => s.title === schema.title).properties[propertyKey];
                newProperty.types = {};
                for (const oldValueTypeName of Object.keys((_j = oldProperty.valueTypes) !== null && _j !== void 0 ? _j : {})) {
                    const oldValueType = oldProperty.valueTypes[oldValueTypeName];
                    if (oldValueTypeName === "integer") {
                        newProperty.types.integer = oldValueType;
                    }
                    else if (oldValueTypeName === "number") {
                        newProperty.types.number = oldValueType;
                    }
                    else if (oldValueTypeName === "string") {
                        newProperty.types.string = oldValueType;
                    }
                    else if (oldValueTypeName === "boolean") {
                        newProperty.types.boolean = oldValueType;
                    }
                    else if (oldValueTypeName === "date") {
                        newProperty.types.date = oldValueType;
                    }
                    else if (oldValueTypeName === "date-time") {
                        newProperty.types["date-time"] = oldValueType;
                    }
                    else if (oldValueTypeName === "object") {
                        newProperty.types.object = oldValueType;
                    }
                    else if (oldValueTypeName === "array") {
                        newProperty.types.array = oldValueType;
                    }
                    else if (oldValueTypeName === "null") {
                        newProperty.types.null = oldValueType;
                    }
                }
                delete oldProperty.valueTypes;
            }
        }
    }
    if (packageFileObject.$schema.endsWith("v0.9.0.json")) {
        packageFileObject.$schema = packageFileObject.$schema.replace("0.9.0", "0.31.5");
        const oldPackageFile = packageFileObject;
        const recurseProperties = (properties) => {
            for (const propertyKey of Object.keys(properties)) {
                const oldProperty = properties[propertyKey];
                const newProperty = properties[propertyKey];
                if (oldProperty.properties != null && oldProperty.types.object != null) {
                    newProperty.types.object = {
                        ...oldProperty.types.object,
                        objectProperties: oldProperty.properties
                    };
                    recurseProperties(oldProperty.properties);
                    delete oldProperty.properties;
                }
            }
        };
        for (const schema of oldPackageFile.schemas) {
            recurseProperties(schema.properties);
        }
    }
    if (packageFileObject.$schema.endsWith("v0.31.5.json")) {
        packageFileObject.$schema = packageFileObject.$schema.replace("0.31.5", "0.32.1");
        const oldPackageFile = packageFileObject;
        if (oldPackageFile.readmeFile != null && oldPackageFile.readmeMarkdown != null)
            delete oldPackageFile.readmeFile;
        if (oldPackageFile.licenseFile != null && oldPackageFile.licenseMarkdown != null)
            delete oldPackageFile.licenseFile;
        if (oldPackageFile.readmeFile == null && oldPackageFile.readmeMarkdown == null)
            oldPackageFile.readmeMarkdown =
                (_k = "# " + oldPackageFile.displayName) !== null && _k !== void 0 ? _k : oldPackageFile.packageSlug + "\n\n No readme defined";
        if (oldPackageFile.licenseFile == null && oldPackageFile.licenseMarkdown == null)
            oldPackageFile.licenseMarkdown = "No license defined";
    }
    return packageFileObject;
}
exports.upgradePackageFile = upgradePackageFile;
async function validatePackageFileInBrowser(packageFile) {
    const ajv = new ajv_1.default({
        format: false
    });
    let packageSchemaFile;
    const schemaVersion = getSchemaVersionFromPackageFile(packageFile);
    const response = await (0, cross_fetch_1.default)("/static/datapm-package-file-schema-v" + schemaVersion.format() + ".json");
    if (response.status > 199 && response.status < 300) {
        packageSchemaFile = await response.text();
    }
    else {
        throw new Error("ERROR_FINDING_PACKAGE_SCHEMA_FILE " + response.status);
    }
    let schemaObject;
    try {
        schemaObject = JSON.parse(packageSchemaFile);
    }
    catch (error) {
        throw new Error("ERROR_PARSING_PACKAGE_SCHEMA_FILE: " + error.message);
    }
    if (!ajv.validateSchema(schemaObject)) {
        throw new Error("ERROR_READING_SCHEMA");
    }
    const ajvResponse = ajv.validate(schemaObject, packageFile);
    if (!ajvResponse) {
        throw new Error("INVALID_PACKAGE_FILE_SCHEMA: " + JSON.stringify(ajv.errors));
    }
}
exports.validatePackageFileInBrowser = validatePackageFileInBrowser;
function getSchemaVersionFromPackageFile(packageFileObject) {
    let packageFileSchemaUrl = packageFileObject.$schema;
    if (packageFileSchemaUrl == null)
        packageFileSchemaUrl = "https://datapm.io/static/datapm-package-file-schema-v0.1.0.json";
    const schemaVersion = packageFileSchemaUrl.match(/v(.*)\.json/i);
    if (schemaVersion == null)
        throw new Error("ERROR_SCHEMA_VERSION_NOT_RECOGNIZED - " + packageFileSchemaUrl);
    return new semver_1.SemVer(schemaVersion[1]);
}
exports.getSchemaVersionFromPackageFile = getSchemaVersionFromPackageFile;
function validatePackageFile(packageFile) {
    const ajv = new ajv_1.default({
        format: false
    });
    let packageSchemaFile;
    const schemaVersion = getSchemaVersionFromPackageFile(packageFile);
    const datapmVersion = new semver_1.SemVer(DataPMVersion_1.DATAPM_VERSION);
    if (schemaVersion.compare(datapmVersion) === 1) {
        throw new Error("ERROR_SCHEMA_VERSION_TOO_NEW - " + schemaVersion.format());
    }
    const schemaFileName = "packageFileSchema-v" + schemaVersion.format() + ".json";
    try {
        const pathToSchemaFile = path_1.default.join(__dirname, "..", schemaFileName);
        packageSchemaFile = fs_1.default.readFileSync(pathToSchemaFile, "utf8");
    }
    catch (error) {
        try {
            const pathToSchemaFile = path_1.default.join("node_modules", "datapm-lib", schemaFileName);
            packageSchemaFile = fs_1.default.readFileSync(pathToSchemaFile, "utf8");
        }
        catch (error) {
            try {
                packageSchemaFile = fs_1.default.readFileSync(schemaFileName, "utf8");
            }
            catch (error) {
                const pathToSchemaFile = path_1.default.join(__dirname, "..", "lib", schemaFileName);
                packageSchemaFile = fs_1.default.readFileSync(pathToSchemaFile, "utf8");
            }
        }
    }
    let schemaObject;
    try {
        schemaObject = JSON.parse(packageSchemaFile);
    }
    catch (error) {
        throw new Error("ERROR_PARSING_PACKAGE_SCHEMA_FILE: " + error.message);
    }
    if (!ajv.validateSchema(schemaObject)) {
        throw new Error("ERROR_READING_SCHEMA");
    }
    const response = ajv.validate(schemaObject, packageFile);
    if (!response) {
        throw new Error("INVALID_PACKAGE_FILE_SCHEMA: " + JSON.stringify(ajv.errors));
    }
}
exports.validatePackageFile = validatePackageFile;
//# sourceMappingURL=PackageUtil.js.map